import { render, staticRenderFns } from "./editorDialog.vue?vue&type=template&id=38d9285d&scoped=true&"
import script from "./editorDialog.vue?vue&type=script&lang=js&"
export * from "./editorDialog.vue?vue&type=script&lang=js&"
import style0 from "./editorDialog.vue?vue&type=style&index=0&id=38d9285d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d9285d",
  null
  
)

export default component.exports